import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Component that alerts if you click outside of it
 */
export default class TypeOutsideAlerter extends Component {

  constructor(props) {
    super(props);
    this.setStatusRef = this.setStatusRef.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  /**
   * Set the wrapper ref
   */
  setStatusRef(node) {
    this.statusWrapperRef = node;
  }

  /**
   * Alert if clicked on outside of element
   */
  handleClickOutside(event) {
    if (this.statusWrapperRef && !this.statusWrapperRef.contains(event.target)) {
      this.props.closeTypeFilter();
    }
  }

  render() {
    return <div ref={this.setStatusRef}>{this.props.children}</div>;
  }
}

TypeOutsideAlerter.propTypes = {
  children: PropTypes.element.isRequired,
};
